// the only reason this exists is to mock it easily. i gave up with Intl.DateTimeFormat
export default () => {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
